<section class="container-style pb-2">
  <div class="d-flex justify-content-between align-items-center px-1 py-2 border-bottom">
    <div>
      <span class="fw-bold d-flex align-items-center"><i class="pi pi-list me-2">
        </i>Familias asignadas <p-badge severity="secondary" [value]="conceptFamilies.length" />
      </span>
    </div>
    <div class="d-flex align-items-center gap-2">
      <app-custom-button *ngIf="selectedIdsToDelete.length > 0" [title]="'Eliminar'"
        [label]="'Eliminar (' + selectedIdsToDelete.length + ')'" [icon]="'pi pi-trash'" [severity]="'danger'"
        [width]="'auto'" (onClick)="deleteSome()"></app-custom-button>
      <app-custom-button [title]="'Agregar'" [label]="'Agregar'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
        [variant]="undefined" (onClick)="openFamiliesSelectionModal()"></app-custom-button>
      <app-custom-modal #familiesModal [label]="'Selección de familias'" [header]="'Selección de familias'"
        [width]="'70rem'" [children]="componentTableSelection" [inputs$]="inputsForFamiliesSelection$"
        [output$]="outputFamilies$" (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
    </div>
  </div>
  <div id="table-assign-families" *ngIf="conceptFamilies.length > 0">
    <p-table [value]="conceptFamilies" [rows]="10" [scrollable]="true" stripedRows showGridlines
      styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px" class="text-center">
            <p-checkbox [binary]="true" size="small" autocomplete="off" [(ngModel)]="selectAll"
              (onChange)="onSelectAllChange($event)"></p-checkbox>
          </th>
          <th style="width: 50px">Reg.</th>
          <th class="text-center" style="width: 70px">Familia</th>
          <th>Nombre Familia</th>
          <th class="text-center" style="width: 130px">Dispersa Artículo</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-family let-colIndex=rowIndex>
        <tr>
          <td class="text-center">
            <p-checkbox [binary]="true" size="small" autocomplete="off" [(ngModel)]="family.selected"
              (onChange)="onRowSelectChange(family)"></p-checkbox>
          </td>
          <td class="text-center">{{ colIndex + 1 }}</td>
          <td class="text-center">{{ family.family.code }}</td>
          <td>{{ family.family.name }}</td>
          <td class="text-center">
            <p-checkbox [binary]="true" size="small" autocomplete="off" [(ngModel)]="family.swDispersedArticle"
              (onChange)="dispersedArticle(family, $event)"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>